$(document).ready(function () {
  $(".SlickCarousel").slick({
    arrows: true,
    centerMode: false,
    centerPadding: "0px",
    infinite: true,
    slidesToShow: 7,
    slidesToScroll: 1,
    ltr: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          centerMode: true,
          centerPadding: "0px",
          infinite: true,
          slidesToShow: 4,
          slidesToScroll: 1,
          ltr: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          centerMode: false,
          centerPadding: "0px",
          infinite: true,
          slidesToShow: 3,
          slidesToScroll: 3,
          ltr: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          centerMode: false,
          centerPadding: "0px",
          infinite: true,
          slidesToShow: 3,
          slidesToScroll: 3,
          ltr: true,
        },
      },
    ],
  });
});
